<div class="main_container">
	<div class="container-fluid" style="overflow: scroll; height: 100vh;">
		<h1 class="my-3">{{post.title}}</h1>
		<div class="card p-1 p-md-3 my-3">
			<div class="mark_down" [innerHTML]="post.post | marked"></div>
		</div>
	</div>
</div>
